module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep1.cf367902.jpg";